import BaseComponent from 'foundation/base-component';

export default class UpdateAppComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    static getRequiredRefs() {
        return ['refresh'];
    }

    init() {
        this.refs.refresh.addEventListener('click', this.onRefreshClick);
    }

    onRefreshClick = (e) => {
        window.location.reload();
    }
}
